import styled from '@emotion/styled';
import { Button } from '@edusense/shared-ui-kit';
// --- Styled Components ---
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme })=>theme.spacing.lg};
  padding: ${({ theme })=>theme.spacing.lg};
  background-color: ${({ theme })=>theme.palette?.background?.paper || '#fff'};
  border-radius: ${({ theme })=>theme.shape?.borderRadius || '4'}px;
  box-shadow: ${({ theme })=>theme.shadows?.sm || 'none'};
`;
export const FormGroup = styled.div`
  margin-bottom: 16px;
`;
export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 0.9rem;
`;
export const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  box-sizing: border-box;
`;
export const SubmitButton = styled(Button)`
  /* 필요 시 추가 스타일 */
`;
export const DeleteButton = styled(Button)`
  background-color: #ef4444; // red-500
  color: white;

  &:hover {
    background-color: #dc2626; // red-600
  }
`;
export const FileInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
export const FileInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: #333;
  flex-grow: 1;
  min-width: 0;
`;
export const FileName = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const SectionDivider = styled.hr`
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  margin: 20px 0;
`;
export const SectionTitle = styled.h3`
  font-size: 1.1rem;
  margin-bottom: 15px;
  color: #555;
`;
export const PreviewContainer = styled.div`
  padding: 15px;
  border: 1px dashed #ccc;
  border-radius: 4px;
  background-color: #f9fafb;
  color: #333;
  min-height: 500px;
  overflow-y: visible;

  h1, h2, h3, h4, h5, h6 { margin-top: 1em; margin-bottom: 0.5em; color: #111; }
  p { margin-bottom: 0.8em; line-height: 1.6; }
  ul, ol { margin-left: 20px; margin-bottom: 0.8em; }
  li { margin-bottom: 0.3em; }
  code { background-color: #eee; padding: 0.2em 0.4em; border-radius: 3px; font-family: monospace; }
  pre code { background-color: transparent; padding: 0; }
  pre { background-color: #eee; padding: 10px; border-radius: 4px; overflow-x: auto; }
  blockquote { border-left: 4px solid #ccc; padding-left: 10px; color: #666; margin-left: 0; }
`;
export const EditorModeToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
`;
export const EditorHelpRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  color: #4b5563;
  font-size: 0.9rem;
`;
export const EditorHelpLink = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: none;
  background: transparent;
  color: #2563eb;
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: #1d4ed8;
  }
`;
export const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid ${(props)=>props.$active ? '#2563eb' : '#e5e7eb'};
  background-color: ${(props)=>props.$active ? '#eff6ff' : 'transparent'};
  color: ${(props)=>props.$active ? '#2563eb' : '#4b5563'};
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${(props)=>props.$active ? '#eff6ff' : '#f9fafb'};
  }
`;
export const InlineBlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin-top: 20px;
`;
export const BlockWithPreviewContainer = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 16px;
  transition: all 0.3s ease;
  box-shadow: ${(props)=>props.$isOpen ? '0 2px 8px rgba(0, 0, 0, 0.05)' : 'none'};
`;
export const BlockContentWithPreview = styled.div`
  display: flex;
  flex-direction: row;
  border-top: 1px solid #e5e7eb;
  max-height: ${(props)=>props.$isOpen ? '2000px' : '0px'};
  opacity: ${(props)=>props.$isOpen ? '1' : '0'};
  visibility: ${(props)=>props.$isOpen ? 'visible' : 'hidden'};
  overflow: hidden;
  transition: max-height 0.5s ease, opacity 0.3s ease, visibility 0s linear ${(props)=>props.$isOpen ? '0s' : '0.5s'};

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
export const BlockEditorPane = styled.div`
  flex: 1;
  padding: 0;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  min-height: 50px;
  overflow: hidden;

  @media (max-width: 768px) {
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
    min-height: 50px;
  }
`;
export const BlockPreviewPane = styled.div`
  flex: 1;
  padding: ${(props)=>props.$isOpen ? '12px' : '0'};
  background-color: #f9fafb;
  transition: padding 0.3s ease;
`;
export const BlockEditorToolbar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
  padding: 8px;
  background-color: #f9fafb;
  border-radius: 4px;
`;
export const BlockToolbarGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
export const BlockToolbarLabel = styled.div`
  font-size: 0.8rem;
  font-weight: 500;
  color: #6b7280;
  width: 100%;
  margin-bottom: 4px;
  padding-bottom: 4px;
  border-bottom: 1px solid #e5e7eb;
`;
export const BlockButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
  background-color: white;
  color: #4b5563;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #f3f4f6;
    border-color: #d1d5db;
  }
`;
export const BlocksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
`;
export const BlockItem = styled.div`
  border: 1px solid ${(props)=>props.$isDragging ? '#2563eb' : '#e5e7eb'};
  border-radius: 4px;
  background-color: white;
  box-shadow: ${(props)=>props.$isDragging ? '0 4px 6px rgba(0, 0, 0, 0.1)' : 'none'};
  transition: border-color 0.2s, box-shadow 0.2s;
  overflow: hidden;
`;
export const getBlockTypeColor = (type)=>{
    switch(type){
        case 'markdown':
            return '#3b82f6';
        case 'table':
            return '#10b981';
        case 'terminal':
            return '#6366f1';
        case 'quiz':
            return '#f59e0b';
        case 'html':
            return '#ef4444';
        case 'image':
            return '#8b5cf6';
        default:
            return '#6b7280';
    }
};
export const BlockTypeLabel = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  color: white;
  background-color: ${(props)=>getBlockTypeColor(props.$type)};
  margin-right: 6px;
`;
export const BlockHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background-color: ${(props)=>`${getBlockTypeColor(props.$type)}10`};
  border-bottom: ${(props)=>props.$isOpen ? `1px solid ${getBlockTypeColor(props.$type)}30` : 'none'};
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${(props)=>`${getBlockTypeColor(props.$type)}20`};
  }
`;
export const BlockSummary = styled.div`
  font-size: 0.85rem;
  color: #4b5563;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  margin-left: 8px;
`;
export const BlockContent = styled.div`
  padding: 12px;
  display: ${(props)=>props.$isOpen ? 'block' : 'none'};
`;
export const DragHandle = styled.div`
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: ${(props)=>getBlockTypeColor(props.$type)};

  &:active {
    cursor: grabbing;
  }
`;
export const BlockTypeSelect = styled.select`
  padding: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background-color: white;
  font-size: 0.9rem;
  margin-left: 8px;
`;
export const MarkdownEditorContainer = styled.div`
  display: flex;
  position: relative;
  min-height: 600px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
    min-height: 800px;
  }
`;
export const EditorColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;
export const PreviewColumn = styled.div`
  flex: 1;
  min-width: 0;
  border-left: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    border-left: none;
    border-top: 1px solid #e5e7eb;
  }
`;
export const PreviewContentArea = styled(PreviewContainer)`
  flex-grow: 1;
  border: none;
  border-radius: 0;
  background-color: #f9fafb;
  padding: 15px;
  min-height: auto;
`;
export const BlockTypeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  color: #4b5563;
`;
export const BlockActions = styled.div`
  display: flex;
  gap: 4px;
`;
export const BlockAction = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #f3f4f6;
    color: #1f2937;
    transform: scale(1.1);
  }
`;
export const BlockInput = styled.textarea`
  width: 100%;
  padding: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  font-size: 0.9rem;
  font-family: inherit;
  min-height: 100px;
  overflow-y: hidden;
  resize: none;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
  }
`;
export const BlockMetadata = styled.span`
  font-size: 0.7rem;
  color: #6b7280;
  margin-left: 4px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const BlockDropZone = styled.div`
  height: ${(props)=>props.$isActive ? '80px' : '20px'};
  margin: 4px 0;
  border-radius: 4px;
  background-color: ${(props)=>props.$isActive ? 'rgba(37, 99, 235, 0.1)' : '#f3f4f6'};
  border: ${(props)=>props.$isActive ? '2px dashed #2563eb' : '1px dashed #d1d5db'};
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    height: 36px;
    background-color: rgba(37, 99, 235, 0.05);
    border: 2px dashed #93c5fd;
  }

  span {
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  &:hover span {
    opacity: 1;
  }
`;
export const DraggableBlockButton = styled(BlockButton)`
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;
export const BlockTypeDropdown = styled.div`
  position: absolute;
  ${(props)=>props.$position === 'top' ? 'bottom: 100%;' : 'top: 0;'}
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 16px;
  min-width: 500px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  margin: ${(props)=>props.$position === 'top' ? '0 0 8px 0' : '8px 0 0 0'};
`;
export const HorizontalMenuContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const MenuHeader = styled.div`
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
  text-align: center;
  width: 100%;
`;
export const MenuButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
`;
export const BlockMenuButton = styled(DraggableBlockButton)`
  flex: 0 0 auto;
  min-width: 120px;
  text-align: center;
  justify-content: center;
`;
export const RotateIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  transform: rotate(${(props)=>props.$isOpen ? '180deg' : '0deg'});
`;
// ItemTypesForBlockCreation은 스타일 파일에서 직접 사용되지 않으므로,
// 필요하다면 index.tsx나 useLectureEditForm.ts에 남겨두거나 types.ts로 옮깁니다.
// 여기서는 주석 처리합니다.
/*
export const ItemTypesForBlockCreation = {
  MARKDOWN: 'markdown',
  TABLE: 'table',
  TERMINAL: 'terminal',
  QUIZ: 'quiz',
  HTML: 'html',
  IMAGE: 'image',
} as const;
*/ export const ErrorMessage = styled.p`
  color: red;
  font-size: 0.875rem;
  margin-top: 0.25rem;
`;
export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end; // 또는 원하는 정렬 방식
  margin-top: 1.5rem; // 예시 간격
`;
